export interface ILogin {
    access_token: string;
    permissions: string[];
}
